import classNames from "classnames";
import {Radio} from "./Radio";

export type BigRadioProps = {
  value?: string,
  onChange: () => void,
  checked: boolean,
  label: string,
  description: string,
  name: string,
  activeClass?: string,
  inactiveClass?: string
}
export const BigRadio = (props: BigRadioProps) => {
  const colorClasses = props.checked ? (props.activeClass || "bg-blue-4 border-blue-3") : (props.inactiveClass || "bg-white border-gray-7");
  return (
    <label className={classNames(
      "block flex-grow rounded-md border p-4 cursor-pointer",
      colorClasses
    )}>
      <div className="flex items-center gap-2">
        <Radio
          name={props.name}
          label={props.label}
          disabled={false}
          hasError={false}
          checked={props.checked}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
      <span className="font-style-body-xs text-gray-2">{props.description}</span>
    </label>
  );
}
